var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2372 2.28851C15.6301 2.41949 15.8425 2.84423 15.7115 3.23719L9.71153 21.2372C9.58055 21.6301 9.15581 21.8425 8.76285 21.7115C8.36989 21.5805 8.15752 21.1558 8.28851 20.7628L14.2885 2.76285C14.4195 2.36989 14.8442 2.15752 15.2372 2.28851ZM17.4697 6.96967C17.7626 6.67678 18.2374 6.67678 18.5303 6.96967L23.0303 11.4697C23.3232 11.7626 23.3232 12.2374 23.0303 12.5303L18.5303 17.0303C18.2374 17.3232 17.7626 17.3232 17.4697 17.0303C17.1768 16.7374 17.1768 16.2626 17.4697 15.9697L21.4393 12L17.4697 8.03033C17.1768 7.73744 17.1768 7.26256 17.4697 6.96967ZM6.53033 8.03033C6.82322 7.73744 6.82322 7.26256 6.53033 6.96967C6.23744 6.67678 5.76256 6.67678 5.46967 6.96967L0.96967 11.4697C0.676777 11.7626 0.676777 12.2374 0.96967 12.5303L5.46967 17.0303C5.76256 17.3232 6.23744 17.3232 6.53033 17.0303C6.82322 16.7374 6.82322 16.2626 6.53033 15.9697L2.56066 12L6.53033 8.03033Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCode);
export default __webpack_public_path__ + "static/media/code.350c90c38249daf75dc82f8cd3a5f6eb.svg";
export { ForwardRef as ReactComponent };